import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasProgressBarComponent } from './progress-bar.component';

const COMPONENT = [
  GasProgressBarComponent,
];

@NgModule({
  declarations: [
    COMPONENT,
  ],
  exports: [
    COMPONENT,
  ],
  imports: [
    CommonModule,
  ],
})
export class GasProgressBarModule { }
